class BaseStorage {
  constructor() {
    if (this.constructor === BaseStorage) {
      throw new TypeError(
        'Abstract class "BaseStorage" cannot be instantiated directly.',
      );
    }
  }

  get() {
    throw new Error('Implement `get` method');
  }

  remove() {
    throw new Error('Implement `remove` method');
  }

  set() {
    throw new Error('Implement `set` method');
  }
}

export default BaseStorage;



// WEBPACK FOOTER //
// ./src/utils/storage/BaseStorage.js